<template>
  <div class="barometer-inner-wrapper">
    <div class="barometer-inner-header">
      <h2>Allrounder</h2>

      <!-- <h2>{{employeeNameArray[0]}}</h2>
      <h3>Week {{weeknr}}</h3>-->
    </div>
    <div class="barometer-canvas-wrapper">
      <canvas
        :id="canvasID"
        generateGradient="true"
        width="220"
        height="120"
      ></canvas>
    </div>
    <div class="barometer-footer">
      <div class="barometer-rate ma-0">
        <span v-if="actualPercentage > 100" class="on-fire"></span>
        <div v-if="!hourRateAmmount">
          <span v-if="revenuePerHoursumOBJ && !dyflexis"
            >{{ actualPercentage }} %</span
          >
          <span v-else-if="revenuePerHoursumOBJ && dyflexis"
            >€ {{ revenuePerHoursumOBJ.toFixed(0) }} per uur</span
          >
        </div>
        <div v-else>
          <span>€ {{ actualPercentage }}</span>
          <span v-if="revenuePerHoursumOBJ && !dyflexis" style="font-size:12px"
            >&nbsp; {{ revenuePerHoursumOBJ }}%
          </span>
        </div>
      </div>
      <p v-if="revenue" class="barometer-description">
        De doelstelling is om boven de € {{ employeeTarget.revenue }} te blijven
      </p>
      <p v-if="dyflexis" class="barometer-description">
        Gebasseerd op {{ hours.toFixed(1) }} uren
      </p>

      <div v-else class="barometer-alert">
        <v-alert v-if="!dyflexis" :value="true" type="warning"
          >Er is nog geen doel ingesteld.</v-alert
        >
      </div>
      <p class="barometer-description ma-0" v-if="rate">
        <i>De totale Allround omzet: € {{ rate.toFixed(2) }}</i>
      </p>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import db from "../../firebase/init";
import { bus } from "../../main";
import { log } from "util";
export default {
  props: [
    "level",
    "marks",
    "aperture",
    "colorStop",
    "colorStart",
    "canvasID",
    "employeeName",
    "employeeID",
    "employeeTarget",
    "allRoundEmployees",
    "selectedBranch",
    "weeknr",
    "hourRateAmmount",
  ],
  name: "employeeAllroundBarometer",
  data: () => ({
    mini: true,
    rate: null,
    employeeNameArray: [],
    id: null, //passed getal door
    width: 220,
    hours: 0,
    dyflexis: false,
    canvasRender: null,
    actualPercentage: null, //Status Barometer employee
    revenuePerHoursumOBJ: null,
    revenue: null,
    opts: {
      angle: 0, /// The span of the gauge arc
      lineWidth: 0.26, // The line thickness
      pointer: {
        length: 0.7, // Relative to gauge radius
        strokeWidth: 0.035, // The thickness
        color: "#767676",
      },
      colorStop: "#333",
      colorStart: "#333",
      relativeGaugeSize: true,
      strokeColor: "rgb(204,204,204)",
      limitMax: true, // If false, max value increases automatically if value > maxValue
      generategradient: false,
      highDpiSupport: true,

      // percentColors: [[0.0, "#a9d70b"], [0.5, "#f9c802"], [1.0, "#ff0000"]],
      // staticZones: [
      //   { strokeStyle: "rgb(204,204,204)", min: 0, max: 120, height: 1.0 },
      //   { strokeStyle: "rgb(255,255,255)", min: 99, max: 100, height: 1.2 }
      // ],
      staticLabels: {
        font: "14px sans-serif", // Specifies font
        labels: [100], // Print labels at these values
        color: "#000000", // Optional: Label text color
        fractionDigits: 0, // Optional: Numerical precision. 0=round off.
      },
      // pointer: {
      //   // Extra optional pointer options:
      //   iconPath: "myicon.png", // Icon image source
      //   iconScale: 1, // Size scaling factor
      //   iconAngle: 90.0 // Rotation offset angle, degrees
      // }
    },
  }),

  created() {
    bus.$on("employeeBarometerUpdate", this.updateData);
    this.opts.colorStop = this.colorStop;
  },

  mounted() {
    this.updateData();
  },

  methods: {
    updateData() {
      let theMaxValue = 120;
      const splitEmployeeName = this.employeeName.split(" ");
      this.employeeNameArray = splitEmployeeName;
      this.hours = 0;
      this.revenue = this.employeeTarget.revenue;

      //Gemiddelde per uur
      let revenuePerHoursum = 0;

      this.allRoundEmployees.forEach((o) => {
        if (this.employeeID == o.id) {
          if (o.dyflexisHours) {
            this.dyflexis = true;
            this.hours = o.dyflexisHours;
            this.rate = o.allroundsum;
            this.revenuePerHoursumOBJ = o.allroundsum / o.dyflexisHours;
            // console.log("revenuePerHoursum: ", revenuePerHoursum)
          } else {
            this.actualPercentage = null;
            this.rate = o.allroundsum;
            revenuePerHoursum = o.revenuePerHour;
          }
        }
      });

      // for (let index = 0; index < this.selectedBranch.length; index++) {
      //   this.reportEmployee[index][0].data.employees.forEach(o => {
      //     if (o.id == this.employeeID) {
      //       sumAllround = +o.revenue;
      //     }
      //   });
      // }
      if (!this.dyflexis) {
        if (this.employeeTarget) {
          if (this.employeeTarget.revenue) {
            if (this.hourRateAmmount == true) {
              this.actualPercentage = revenuePerHoursum;
              this.opts.staticLabels.labels = [];
              this.opts.staticLabels.labels.push(this.employeeTarget.revenue);
              this.revenuePerHoursumOBJ = (
                (100 * revenuePerHoursum) /
                this.employeeTarget.revenue
              ).toFixed(1);

              this.revenue = this.employeeTarget.revenue;
            } else {
              this.actualPercentage = (
                (100 * revenuePerHoursum) /
                this.employeeTarget.revenue
              ).toFixed(1);
            }

            // if (this.hourRateAmmount == true) {
            //   this.opts.staticLabels.labels = [];
            //   this.opts.staticLabels.labels.push(this.employeeTarget.revenue);
            //   theMaxValue = this.employeeTarget.revenue + 20;
            //   this.actualPercentage = this.rate.toFixed(2);
            // } else {
            //   theMaxValue = 120;
            //   this.actualPercentage = (
            //     (100 * this.rate) /
            //     this.employeeTarget.revenue
            //   ).toFixed(1);
            // }
          } else if (this.rate > 0) {
            this.revenue = this.employeeTarget.revenue;
            this.actualPercentage = 0;
          } else {
            this.actualPercentage = 0;
            this.revenue = null;
          }
        } else {
          this.actualPercentage = 0;
          this.revenue = null;
        }
      } else {
        this.opts.staticLabels.labels = [];
        this.opts.staticLabels.labels.push(this.revenuePerHoursumOBJ);
        this.actualPercentage = this.revenuePerHoursumOBJ;
      }

      let rate = 0;
      console.log("this.employeeTarget: ", this.employeeTarget);

      if (this.employeeTarget.revenue) {
        rate = this.actualPercentage;
        if (this.employeeTarget && this.employeeTarget.revenue) {
          rate = Math.floor(
            (this.actualPercentage / this.employeeTarget.revenue) * 100,
          );
          if (rate <= 25) {
            this.opts.colorStop = "#ff0a0a";
            this.opts.colorStart = "#ff0a0a";
          } else if (rate <= 50 && rate > 25) {
            this.opts.colorStop = "#f2ce02";
            this.opts.colorStart = "#f2ce02";
          } else if (rate <= 75 && rate > 50) {
            this.opts.colorStop = "#ebff0a";
            this.opts.colorStart = "#ebff0a";
          } else if (rate <= 100 && rate > 75) {
            this.opts.colorStop = "#85e62c";
            this.opts.colorStart = "#85e62c";
          } else if (rate > 100) {
            this.opts.colorStop = "#209c05";
            this.opts.colorStart = "#209c05";
          }
        }
      }

      var opts = this.opts;
      var target = document.getElementById(this.canvasID); // Passeren langs DOM element
      var gauge = new Gauge(target).setOptions(opts); // Unieke Gauge opbouwn

      gauge.maxValue = theMaxValue; // max gauge value
      gauge.setMinValue(0); // min value
      gauge.set(rate); // actual valu0;
    },
  },

  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    // intel() {
    //   if (this.revenue == null) {
    //     return `<span style="">Er is nog geen doel voor deze medewerker ingesteld.</span>`;
    //     // return `<span style="">Er is nog geen doel voor ${this.employeeName} ingesteld.</span>`;
    //   } else {
    //     return `<span style="red">De doelstelling is om boven de 100% te blijven.</span>`;
    //     // return `<span style="red">De doelstelling voor ${this.employeeName} is rond de 100% te blijven.</span>`;
    //   }
    // }
  },
};
</script>
